import styled from 'styled-components';

const colors = {
  text: '#0f2a33',
  muted: '#62737a',
  green: '#12805c',
  activeBackground: '#dcefe6',
  background: '#f1f8f5',
  border: '#e5ecea',
  red: '#c53d3d',
};

export const LSideBar = styled.aside`
  position: sticky;
  top: 0;
  width: 248px;
  height: 100vh;
  flex-shrink: 0;
  display: flex;
  flex-direction: column;
  gap: 24px;
  padding: 24px 16px;
  background: ${colors.background};
  border-right: 1px solid ${colors.border};
  font-family: 'Manrope', sans-serif;

  .logo img {
    display: block;
    width: 112px;
    height: auto;
    margin: 0 8px;
  }

  @media (max-width: 1024px) {
    position: static;
    width: 100%;
    height: auto;
    border-right: none;
    border-bottom: 1px solid ${colors.border};
  }
`;

export const Menu = styled.nav`
  flex: 1;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  gap: 24px;

  ul {
    display: flex;
    flex-direction: column;
    gap: 4px;
    list-style: none;
  }

  a,
  button {
    width: 100%;
    display: flex;
    align-items: center;
    gap: 14px;
    padding: 12px 14px;
    border: none;
    border-radius: 10px;
    background: transparent;
    font-family: inherit;
    font-size: 15px;
    font-weight: 600;
    color: ${colors.text};
    text-decoration: none;
    cursor: pointer;
    transition: background 0.2s;

    svg {
      width: 20px;
      height: 20px;
      color: ${colors.muted};
    }

    &:hover {
      background: ${colors.activeBackground};
    }
  }

  .active {
    background: ${colors.activeBackground};
    color: ${colors.green};
    font-weight: 800;

    svg {
      color: ${colors.green};
    }
  }

  .danger,
  .danger svg {
    color: ${colors.red};
  }
`;

export const Motto = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
  padding: 16px;
  border: 1px solid ${colors.border};
  border-radius: 14px;
  background: #fff;
  font-size: 13px;
  line-height: 1.5;
  color: ${colors.text};

  svg {
    width: 18px;
    height: 18px;
    color: ${colors.green};
  }

  @media (max-width: 1024px) {
    display: none;
  }
`;
